import React from "react";
import { Modal, Button } from "react-bootstrap";
import Dropzone from "react-dropzone";
import { FaTimes } from "react-icons/fa";

const AvatarUploadModal = ({ show, onHide, onDrop }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload New Avatar</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Dropzone
          onDrop={onDrop} // Use the handler passed from parent
          multiple={false}
          accept={{ "image/*": [".jpeg", ".jpg", ".png", ".gif", ".webp"] }} // Added webp
        >
          {({ getRootProps, getInputProps, isDragActive }) => (
            <div
              {...getRootProps()}
              className={`dropzone ${isDragActive ? 'active' : ''}`}
              style={{
                border: `2px dashed ${isDragActive ? '#0d6efd' : '#adb5bd'}`, // Highlight when active
                padding: "40px 20px",
                textAlign: "center",
                cursor: "pointer",
                borderRadius: "8px",
                backgroundColor: isDragActive ? '#e7f1ff' : '#f8f9fa', // Background change on drag
                transition: 'border-color 0.2s ease, background-color 0.2s ease',
              }}
            >
              <input {...getInputProps()} />
              {isDragActive ? (
                 <p className="mb-0 text-primary">Drop the image here...</p>
              ) : (
                <>
                 <p className="mb-1">
                    Drag 'n' drop an image here, or click to select one.
                 </p>
                 <small className="text-muted">(Max file size: 2MB. Allowed types: JPG, PNG, GIF, WEBP)</small>
                </>
              )}
            </div>
          )}
        </Dropzone>
      </Modal.Body>
       <Modal.Footer className="d-flex justify-content-start"> {/* Use justify-content-start as there's only one button */}
        <Button variant="outline-secondary" onClick={onHide}> {/* Changed variant */}
          <FaTimes className="me-1" /> Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AvatarUploadModal;
